// extracted by mini-css-extract-plugin
module.exports = {"MotorDataVoltageItems":"MotorDataVoltageItems__MotorDataVoltageItems___Dy8Hu","TitleWrapper":"MotorDataVoltageItems__TitleWrapper___1zkw2"};